import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Ramp } from "../../../types";
import mixpanel from "../../../utils/mixpanel";

interface RampRowProps {
  ramp: Ramp;
  aircraftCount: number;
  enableScheduling: boolean;
}

export const RampRow: React.FC<RampRowProps> = ({
  ramp,
  aircraftCount,
  enableScheduling,
}) => {
  const navigate = useNavigate();

  const gridColumns = "200px 160px 1fr";

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: gridColumns,
        alignItems: "center",
        gap: 2,
        px: 2.5,
        py: 1.5,
        borderBottom: "1px solid",
        borderColor: "grey.200",
        transition: "background-color 0.15s ease",
        "&:hover": {
          bgcolor: "action.hover",
        },
      }}
    >
      {/* Ramp Name */}
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {ramp.name}
      </Typography>

      {/* Current Aircraft */}
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: "right" }}>
        {aircraftCount}
      </Typography>

      {/* Actions */}
      <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ flexWrap: "nowrap" }}>
        <Button
          size="small"
          variant="contained"
          color="success"
          onClick={() => {
            mixpanel.track("Clicked Ramp", {
              location_name: ramp.name,
              location_type: "ramp",
            });
            navigate(`/ramps/${ramp.id}`);
          }}
          sx={{
            whiteSpace: "nowrap",
            minWidth: "fit-content",
            px: 1.5,
            py: 0.4,
            fontSize: "0.75rem",
            borderRadius: "14px",
          }}
        >
          Current Ramp
        </Button>
        {enableScheduling && (
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => {
              mixpanel.track("Clicked Ramp Schedule", {
                location_name: ramp.name,
                location_type: "ramp",
              });
              navigate(`/ramps/${ramp.id}/schedule`);
            }}
            sx={{
              whiteSpace: "nowrap",
              minWidth: "fit-content",
              px: 1.5,
              py: 0.4,
              fontSize: "0.75rem",
              borderRadius: "14px",
            }}
          >
            Ramp Schedule
          </Button>
        )}
        <Button
          size="small"
          variant="outlined"
          sx={{
            color: "text.primary",
            borderColor: "grey.300",
            whiteSpace: "nowrap",
            minWidth: "fit-content",
            px: 1.5,
            py: 0.4,
            fontSize: "0.75rem",
            borderRadius: "14px",
            "&:hover": {
              borderColor: "grey.400",
              bgcolor: "grey.50",
            },
          }}
          onClick={() => {
            navigate(`/reference-ramps/${ramp.id}`);
          }}
        >
          Edit Tie Down Tenants
        </Button>
      </Stack>
    </Box>
  );
};
